import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl } from 'react-intl'
import FilterActions from '../../misc/FilterActions/FilterActions'
import Module from '../../../components/misc/Module/Module'
import Row from '../../../components/layout/Grid/Row'
import Col from '../../../components/layout/Grid/Col'
import { Input, Select } from 'components/fields'
import { apiFilter, apiAwards } from 'helpers/decorators/api'
import { assessor } from 'redux/modules/api'
import { get } from 'lodash'

const enhance = compose(
    injectIntl,
    connect(
        ({ api, auth }) => ({
          query: api.assessor.participants.filter,
          user: auth.user
        }),
      { setFilter: assessor.participants.setFilter }
    ),
    apiAwards(),
    apiFilter({
      form: 'participants-filter'
    })
)

class ParticipantsFilter extends Component {
  static propTypes = {
    codeLists: PropTypes.object.isRequired,
    user: PropTypes.object,
    intl: PropTypes.object.isRequired
  }

  render() {
    const { user } = this.props

    const assessorUserType = get(user, 'userTypes').filter(ut => ut.userType === 'assessor')

    const organizations = assessorUserType && get(assessorUserType[0], 'organizations')

    const orgList = organizations && organizations.map(o => ({
      label: o.name,
      value: o.id
    }))

    return (

      <Module verticallyNarrow primary>
        <Row alignItems="center" gutters inner>
        <Col flex="0 1 200px">
          <Input
                  label="Search"
                  intlKey="label.search"
                  name="participant_id||participant_name||participant_email@ic"
                  clearable
          />

        </Col>
        <Col flex="0 1 200px">
          <Select
                  label="Award Centre"
                  intlKey="label.award_unit"
                  name="organization_id"
                  options={orgList}
              />
            </Col>
          </Row>
          <Row>
            <Col flex="1 1 auto" alignSelf="flex-end" right>
              <FilterActions
                {...this.props}
              />
            </Col>
          </Row>
        </Module>
    )
  }
}

export default enhance(ParticipantsFilter)
